// ===== Enums =====

import {
    PAGE_ROUTE,
    READER_PARAMS_TYPE,
} from '../enums';

const INTERNAL_POST_LINK_PARAGRAPH_ID_PARAM = 'paragraphId';

/**
 * Builds a canonical in-app reader href that points at a specific paragraph or
 * heading target inside the current post.
 */
const buildInternalPostLinkHref = ({
    chapterId,
    sectionId,
    paragraphId,
}: {
    chapterId?: string,
    sectionId?: string,
    paragraphId: string,
}): string => {
    const normalizedParagraphId = `${paragraphId || ''}`.trim();
    const searchParams = new URLSearchParams();

    const normalizedChapterId = `${chapterId || ''}`.trim();
    if (normalizedChapterId) {
        searchParams.set(READER_PARAMS_TYPE.chapterId.toString(), normalizedChapterId);
    }

    const normalizedSectionId = `${sectionId || ''}`.trim();
    if (normalizedSectionId) {
        searchParams.set(READER_PARAMS_TYPE.sectionId.toString(), normalizedSectionId);
    }

    if (normalizedParagraphId) {
        searchParams.set(INTERNAL_POST_LINK_PARAGRAPH_ID_PARAM, normalizedParagraphId);
    }

    const queryString = searchParams.toString();
    return queryString.length > 0
        ? `/${PAGE_ROUTE.book}?${queryString}`
        : `/${PAGE_ROUTE.book}`;
};

export default buildInternalPostLinkHref;
